/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Column, Row } from 'hedron';
import Background from 'blocks/Background/Background';
import ds from 'designsystem';
import HREFS from 'common/consts/hrefs';
import Container from 'blocks/Container/Container';
import Paragraph from 'elements/Paragraph';
import fb from 'common/images/fb.svg';
import lin from 'common/images/lin.svg';
import zoni from 'common/images/zoni_white.png';
import exlogo from 'common/images/EX_logo.svg';
import ANCHOR from 'common/consts/anchor';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';
import { safeHtmlWithBr } from 'common/methods/string';
import SocialLink from './SocialLink';
import Header from './Header';
import Link, { StyledBlogLink } from 'blocks/StyledLink';

const ParagraphWhite = Paragraph.extend`
  color: ${ds.brand('white')};
  display: flex;
  align-items: center;
  ${({ marginZero }) => (marginZero ? 'margin: 0;' : '')}
`;

const ParagraphWhiteRight = ParagraphWhite.extend`
  justify-content: flex-end;
`;

const ZoniWhite = styled.div`
  display: inline-block;
  background-image: url(${zoni});
  background-size: 100%;
  height: 29px;
  width: ${ds.get('metrics.xxl')};
  margin-bottom: 50px;
  margin-top: ${ds.get('metrics.s')};
`;

const EXLogo = styled.span`
  display: inline-block;
  background-image: url(${exlogo});
  background-repeat: no-repeat;
  height: 16px;
  width: 39px;
  margin-left: 15px;
`;

const borderTop = {
  borderTop: '1px solid rgba(255, 255, 255, .3)',
};

const StyledLink = styled.a`
  color: ${ds.brand('white')};
  text-decoration: none;
`;

const StyledBackground = styled(Background)`
  margin-top: ${ds.get('metrics.xxl')};
`;


@inject('coreStore', 'appStore')
@observer
class Footer extends Component {
  render() {
    const {
      appStore: { currentLanguage },
    } = this.props;
    const {
      coreStore: {
        translations: {
          FOOTER_ADDRESS_UPPER_LINE,
          FOOTER_ADDRESS_BOTTOM_LINE,
          FOOTER_SOCIAL_MEDIA,
          FOOTER_PRODUCTS,
          FOOTER_ABOUT,
          FOOTER_COMPANY,
          FOOTER_PRIVACY_POLICY_LINK,
          FOOTER_REGULATIONS_LINK,
        },
        content: { footerProducts, footerBlogArticleLink },
        isLoaded,
      },
    } = this.props;
    return (
      <StyledBackground color={ds.brand('product')}>
        <Container>
          <Row divisions={12}>
            <Column sm={6} md={4} lg={2}>
              <ZoniWhite />
              <ParagraphWhite
                marginZero
                dangerouslySetInnerHTML={{
                  __html: safeHtmlWithBr(FOOTER_ADDRESS_UPPER_LINE),
                }}
              />
              <ParagraphWhite
                marginZero
                dangerouslySetInnerHTML={{
                  __html: safeHtmlWithBr(FOOTER_ADDRESS_BOTTOM_LINE),
                }}
              />
              <ParagraphWhite marginZero>
                <StyledLink href="mailto: hello@zonifero.com">
                  {'hello@zonifero.com'}
                </StyledLink>
              </ParagraphWhite>
            </Column>
            <Column sm={6} md={4} lg={2} lgShift={2}>
              <Header
                dangerouslySetInnerHTML={{
                  __html: safeHtmlWithBr(FOOTER_PRODUCTS),
                }}
              />
              {isLoaded &&
                footerProducts.map(link => {
                  if (link.url) {
                    return (
                      <StyledLink key={link.system.id} href={link.url}>
                        <ParagraphWhite
                          dangerouslySetInnerHTML={{
                            __html: safeHtmlWithBr(link.description),
                          }}
                        />
                      </StyledLink>
                    );
                  }
                  return (
                    <Link key={link.system.id} to={link.slug}>
                      <ParagraphWhite
                        dangerouslySetInnerHTML={{
                          __html: safeHtmlWithBr(link.description),
                        }}
                      />
                    </Link>
                  );
                })}
            </Column>
            <Column sm={6} md={4} lg={2} lgShift={1}>
              <Header
                dangerouslySetInnerHTML={{
                  __html: safeHtmlWithBr(FOOTER_ABOUT),
                }}
              />

              <StyledBlogLink to={ANCHOR.BLOG[currentLanguage]}>
                <ParagraphWhite>{'Blog'}</ParagraphWhite>
              </StyledBlogLink>
              {FOOTER_PRIVACY_POLICY_LINK && (
                <StyledLink href={ANCHOR.PRIVACY_POLICY[currentLanguage]} rel="nofollow">
                  <ParagraphWhite>
                    {FOOTER_PRIVACY_POLICY_LINK}
                  </ParagraphWhite>
                </StyledLink>
              )}
              {FOOTER_REGULATIONS_LINK && (
                <Link to={ANCHOR.REGULATIONS[currentLanguage]}>
                  <ParagraphWhite>{FOOTER_REGULATIONS_LINK}</ParagraphWhite>
                </Link>
              )}
              {/* Temporary link is switched off */}
              {/* {FOOTER_APPLICATION_REGULATIONS_LINK && ( */}
              {/*  <Link */}
              {/*    to={ANCHOR.APPLICATION_REGULATIONS[currentLanguage]} */}
              {/*  > */}
              {/*    <ParagraphWhite> */}
              {/*      {FOOTER_APPLICATION_REGULATIONS_LINK} */}
              {/*    </ParagraphWhite> */}
              {/*  </Link> */}
              {/* )} */}
              {isLoaded && (
                <Link to={footerBlogArticleLink}>
                  <ParagraphWhite
                    dangerouslySetInnerHTML={{
                      __html: safeHtmlWithBr(FOOTER_COMPANY),
                    }}
                  />
                </Link>
              )}
            </Column>
            <Column sm={6} md={4} lg={2} lgShift={1}>
              <Header
                dangerouslySetInnerHTML={{
                  __html: safeHtmlWithBr(FOOTER_SOCIAL_MEDIA),
                }}
              />
              <StyledLink href={HREFS.FACEBOOK} rel="nofollow">
                <SocialLink custom="background-position: 0 -1px;" image={fb}>
                  {'Facebook'}
                </SocialLink>
              </StyledLink>
              <StyledLink href={HREFS.LINKED_IN} rel="nofollow">
                <SocialLink custom="background-position: 0 -2px;" image={lin}>
                  {'LinkedIn'}
                </SocialLink>
              </StyledLink>
            </Column>
          </Row>
          <Row style={borderTop}>
            <Column sm={12}>
              <ParagraphWhiteRight>
                {'Manufactured at'}
                <StyledLink href={HREFS.EXTRAHUT}>
                  <EXLogo />
                </StyledLink>
              </ParagraphWhiteRight>
            </Column>
          </Row>
        </Container>
      </StyledBackground>
    );
  }
}
export default Footer;



// WEBPACK FOOTER //
// ./src/blocks/Footer/index.jsx